module.exports = "<td class=\"report-enabled\">\r\n    <input type=\"checkbox\" class=\"slider\" value={{Model.Enabled}} id={{Model.ReportCode}} {{#Model.Enabled}}checked{{/Model.Enabled}}/>\r\n</td>\r\n<td class=\"report-name\">\r\n    {{Model.ReportName}}\r\n</td>"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/alerts-report.html
// module id = 369
// module chunks = 1